export default "__VITE_ASSET__x5Apcyof__"